<template>
  <div class="login-index">
    <div class="login-header">
      <a href="/">
        <img
          src="../../assets/img/login/login-logo.png"
          alt=""
          @click="$router.push('/')"
        />
      </a>
    </div>
    <div class="content-box">
      <!-- <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div> -->
      <span class="wel-text">{{
        registerSuccess ? "SUCCESS" : "WELCOME"
      }}</span>
      <div
        class="form-box"
        v-if="!registerSuccess"
        :class="{
          'register-one-box':
            optActive == 'register' && registerStep == 1 && !forget,
          'register-two-box':
            optActive == 'register' && registerStep == 2 && !forget,
          'forget-box': forget
        }"
      >
        <div
          class="form-header"
          :class="{
            'register-header': optActive == 'register' && !forget,
            'forget-header': forget
          }"
        >
          <div
            class="header-item"
            :class="{ active: optActive == 'login' }"
            @click="changeOptActive('login')"
            v-if="!forget"
          >
            登录
          </div>
          <div
            class="header-item"
            :class="{ active: optActive == 'register' }"
            @click="changeOptActive('register')"
            v-if="!forget"
          >
            注册
          </div>
          <div class="header-item active" v-if="forget">密码找回</div>
        </div>
        <template v-if="optActive == 'login' && !forget">
          <el-form
            :model="loginForm"
            :rules="loginRules"
            ref="loginForm"
            class="ruleForm"
            @keyup.enter.native="loginBefore"
          >
            <el-form-item prop="username">
              <el-input
                v-model="loginForm.username"
                placeholder="请输入邮箱"
                id="email"
              >
                <i slot="prefix" class="iconfont iconGroup"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                v-model="loginForm.password"
                placeholder="密码"
                type="password"
                id="password"
              >
                <i slot="prefix" class="iconfont iconsuo"></i>
              </el-input>
            </el-form-item>
          </el-form>
          <div class="other-opt-box">
            <el-checkbox v-model="reUser" @change="optReUser"
              >记住账号</el-checkbox
            >
            <span class="forget-text" @click="forget = true">忘记密码</span>
          </div>
          <div
            class="login-btn"
            @click="loginBefore"
            v-loading="loginBtnLoading"
          >
            <p class="btn-msg-tip">{{ loginMsgTip }}</p>
            <div class="round-group">
              <div class="round one"></div>
              <div class="round two"></div>
              <div class="round three"></div>
              <div class="round four"></div>
              <div class="round icon-wrapper">
                <i class="iconfont icondenglu"></i>
              </div>
            </div>
            <span>登录</span>
          </div>
        </template>
        <template v-if="optActive === 'register' && !forget">
          <div v-show="registerStep === 1">
            <el-form
              :model="registerOneForm"
              :rules="registerOneRules"
              ref="registerOneForm"
              class="ruleForm"
            >
              <el-form-item prop="email">
                <el-input
                  v-model="registerOneForm.email"
                  placeholder="登录邮箱，请使用企业邮箱"
                >
                </el-input>
                <template #error="{ error }">
                  <div class="error" style="right: 0;">
                    <p v-if="error === 'enterpriseMail'">
                      <span>暂不支持公共邮箱注册，请输入您的企业邮箱。</span>
                      <span class="feedback-btn" @click="openFeedback"
                        >反馈错误</span
                      >
                    </p>
                    <span v-else>{{ error }}</span>
                  </div>
                </template>
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  v-model="registerOneForm.password"
                  placeholder="请输入密码"
                  type="password"
                ></el-input>
              </el-form-item>
              <el-form-item prop="checkPass" style="margin-bottom:34px;">
                <el-input
                  v-model="registerOneForm.checkPass"
                  placeholder="请确认密码"
                  type="password"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="next-btn" @click="registerNext">下一步</div>
          </div>
          <div v-show="registerStep == 2">
            <el-form
              :model="registerTwoForm"
              :rules="registerTwoRules"
              ref="registerTwoForm"
              class="ruleForm"
            >
              <el-form-item prop="name">
                <el-input
                  v-model="registerTwoForm.name"
                  placeholder="请输入您的姓名"
                ></el-input>
              </el-form-item>
              <el-form-item prop="company">
                <el-input
                  v-model="registerTwoForm.company"
                  placeholder="请输入公司名称"
                ></el-input>
              </el-form-item>
              <el-form-item prop="position">
                <el-select
                  v-model="registerTwoForm.position"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择您的岗位(可自行输入)"
                >
                  <el-option
                    label="数据安全部门"
                    value="数据安全部门"
                  ></el-option>
                  <el-option
                    label="网络安全部门"
                    value="网络安全部门"
                  ></el-option>
                  <el-option label="风控部门" value="风控部门"></el-option>
                  <el-option label="合规部门" value="合规部门"></el-option>
                  <el-option label="代理商" value="代理商"></el-option>
                  <el-option label="集成商" value="集成商"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="focus_area">
                <el-select
                  v-model="registerTwoForm.focus_area"
                  multiple
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择您感兴趣的领域(可自行输入)"
                >
                  <el-option label="API安全" value="API安全"></el-option>
                  <el-option label="数据合规" value="数据合规"></el-option>
                  <el-option
                    label="数据泄露监测"
                    value="数据泄露监测"
                  ></el-option>
                  <el-option label="业务风控" value="业务风控"></el-option>
                  <el-option label="业务情报" value="业务情报"></el-option>
                  <el-option label="品牌保护" value="品牌保护"></el-option>
                  <el-option label="渗透测试" value="渗透测试"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="phone">
                <el-input
                  v-model="registerTwoForm.phone"
                  placeholder="请输入手机号码"
                ></el-input>
              </el-form-item>
              <el-form-item prop="code">
                <el-input
                  v-model="registerTwoForm.code"
                  placeholder="请输入验证码"
                >
                  <div
                    slot="suffix"
                    class="send-code-btn"
                    :class="{
                      'disabled-btn':
                        !phoneReg.test(registerTwoForm.phone) || sendCodeStatus
                    }"
                    @click="sendCodeBefore"
                  >
                    {{ sendCodeText }}
                  </div>
                </el-input>
              </el-form-item>
            </el-form>
            <div class="read-box">
              <el-checkbox
                v-model="registerTwoForm.readCheck"
                @change="readChange"
                >我已阅读并同意</el-checkbox
              >
              <a target="_blank" href="/static/thpact.pdf"
                >《永安在线注册协议》</a
              >
              <p v-if="showReadTip" class="read-tip">您还未同意注册协议</p>
            </div>
            <div class="register-btn-group">
              <div class="prev-btn" @click="registerStep = 1">上一步</div>
              <div
                class="register-btn"
                @click="register"
                v-loading="registerBtnLoading"
              >
                <span>注册</span>
                <p class="btn-msg-tip">{{ registerMsgTip }}</p>
              </div>
            </div>
          </div>
        </template>
        <template v-if="forget">
          <el-form
            :model="forgetForm"
            :rules="forgetRules"
            ref="forgetForm"
            class="ruleForm"
          >
            <el-form-item prop="email" style="margin-bottom:43px;">
              <el-input
                v-model="forgetForm.email"
                placeholder="请输入您的注册邮箱"
              ></el-input>
            </el-form-item>
          </el-form>
          <div
            class="send-set-btn"
            @click="findBefore"
            v-loading="forgetBtnLoading"
          >
            <span>发送重置密码邮件</span>
            <p class="btn-msg-tip">{{ forgetTip }}</p>
          </div>
          <div class="return-login-btn" @click="forget = false">返回登录</div>
        </template>
      </div>
      <div class="register-success-box" v-if="registerSuccess">
        <img src="../../assets/img/login/register-success.png" alt="" />
        <p>
          恭喜您成功注册Karma业务情报搜索引擎！
          <span>前往邮箱验证</span>后即可开启业务情报之旅。
        </p>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="354px"
      top="30vh"
      custom-class="success-tip-dialog"
    >
      <div class="dialog-content">
        <img src="../../assets/img/login/email@2x.png" alt="" />
        <p>邮件已发送，请前往邮箱验证</p>
        <div class="sure-btn" @click="dialogVisible = false">确认</div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="feedBackVisible"
      title="反馈"
      width="368px"
      custom-class="feedbackDialog"
      @close="closeFeedback"
    >
      <el-form
        ref="feedbackFormCom"
        :model="feedbackForm"
        :rules="feedbackRule"
        v-if="!feedbackSuccess"
      >
        <el-form-item prop="email">
          <el-input
            v-model.trim="feedbackForm.email"
            placeholder="请输入您的企业邮箱"
            size="large"
          ></el-input>
        </el-form-item>
        <el-form-item prop="company">
          <el-input
            v-model.trim="feedbackForm.company"
            placeholder="请输入您的企业名称"
            size="large"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="feedbackForm.domain"
            placeholder="请输入您的企业官网网址"
            size="large"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div class="feedback-success" v-else>
        <p>感谢您的反馈，</p>
        <p>我们会在3个工作日内核实您提交的内容</p>
      </div>
      <template #footer>
        <span class="dialog-footer" v-if="!feedbackSuccess">
          <el-button @click="closeFeedback" size="large">取消</el-button>
          <el-button type="primary" @click="submitFeedback" size="large"
            >确定</el-button
          >
        </span>
        <span class="dialog-footer" v-else>
          <el-button type="primary" @click="closeFeedback" size="large"
            >知道了</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSmsCaptha,
  tencentCaptcha,
  checkSmsCaptha,
  getEmailType,
  postFeedBack
} from "../../services/interface";
import { api } from "../../services/api";
import http from "../../services/http";
import weakPassword from "./weakPassword";
import { encryptData, registerEncrypt } from "@/util/encrypt";
import { getLocalStorage, getCookie } from "@/util/common";
export default {
  data() {
    const phoneValid = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入手机号码"));
      } else if (!this.phoneReg.test(value)) {
        return callback(new Error("电话号码格式错误"));
      } else {
        callback();
      }
    };
    var codeValid = (rule, value, callback) => {
      if (value.length !== 6) {
        return callback(new Error("请输入6位验证码"));
      } else {
        callback();
      }
    };
    const checkPassValid = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请再次输入密码"));
      } else {
        if (value !== this.registerOneForm.password) {
          return callback(new Error("两次输入密码不一致"));
        }
      }
      callback();
    };
    const passwordValid = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入密码"));
      }
      if (value.length < 8 || value.length > 190) {
        return callback(new Error("密码长度请保持在8位以上"));
      }
      if (/^[0-9]+$/.test(value)) {
        return callback(new Error("密码不能为纯数字"));
      }
      if (/^[a-zA-Z]+$/.test(value)) {
        return callback(new Error("密码不能为纯字母"));
      }
      if (weakPassword.includes(value)) {
        return callback(
          new Error("密码强度低，请避免使用生日、姓名、连续数字或字母等")
        );
      }
      callback();
    };
    const emailValid = async (rule, value, callback) => {
      const res = await getEmailType({ email: value })
        .then(res => {
          if (res.data.email_type !== 3) {
            return false;
          } else {
            return true;
          }
        })
        .catch(() => {
          return false;
        });
      res ? callback() : callback(new Error("enterpriseMail"));
    };
    return {
      optActive: "login",
      forget: false,
      registerStep: 1, // 代表注册到第几步了
      phoneReg: /^1[3456789]\d{9}$/,
      loginForm: {
        username: "",
        password: ""
      },
      loginRules: {
        username: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱地址", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      registerOneForm: {
        email: "",
        password: "",
        checkPass: ""
      },
      registerTwoForm: {
        name: "",
        company: "",
        position: "",
        focus_area: [],
        phone: "",
        code: ""
      },
      registerOneRules: {
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱地址", trigger: "blur" },
          { validator: emailValid, trigger: "blur" }
        ],
        password: [{ validator: passwordValid, trigger: "blur" }],
        checkPass: [{ validator: checkPassValid, trigger: "blur" }]
      },
      registerTwoRules: {
        phone: [{ validator: phoneValid, trigger: "blur" }],
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { validator: codeValid, trigger: "blur" }
        ],
        name: [
          { required: true, message: "请输入您的姓名", trigger: "blur" },
          {
            min: 2,
            max: 18,
            message: "字段长度请保持在2-18位",
            trigger: ["blur", "change"]
          }
        ],
        company: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
          {
            min: 2,
            max: 128,
            message: "字段长度请保持在2-128位",
            trigger: "blur"
          }
        ],
        position: [
          { required: true, message: "请选择您的岗位", trigger: "change" },
          {
            min: 1,
            max: 32,
            message: "字段长度请保持在1-32位",
            trigger: ["blur", "change"]
          }
        ],
        focus_area: [
          { required: true, message: "请选择您感兴趣的领域", trigger: "change" }
        ]
      },
      sendCodeText: "发送验证码",
      sendCodeStatus: false, // 发送验证码按钮是否可以点击，为true的时候不可以
      forgetForm: {
        email: ""
      },
      forgetRules: {
        email: [
          { required: true, message: "请输入您的注册邮箱", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱地址", trigger: "blur" }
        ]
      },
      reUser: false, // 记住账号
      readCheck: false, // 阅读协议
      showReadTip: false, // 阅读协议提示
      loginBtnLoading: false, // 登录按钮loading
      registerBtnLoading: false, // 注册按钮Loading
      forgetBtnLoading: false, // 找回密码按钮Loading
      loginMsgTip: "", // 登录错误提示
      registerMsgTip: "", // 注册错误提示
      forgetTip: "", // 找回密码错误提示
      dialogVisible: false, // 成功弹窗
      morePowerVisible: false, // 更多权限弹窗
      registerSuccess: false, // 表示注册成功
      registerOneFormStr: "", // 注册第一步表单字段的json字符串
      registerTwoFormStr: "", // 注册第二步表单字段的json字符串
      feedBackVisible: false,
      feedbackSuccess: false,
      feedbackForm: {
        email: "",
        company: "",
        domain: ""
      },
      feedbackRule: {
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱格式", trigger: "blur" }
        ],
        company: [
          { required: true, message: "请输入企业名称", trigger: "blur" }
        ]
      }
    };
  },
  watch: {
    forget(val) {
      this.$nextTick(() => {
        if (val) {
          this.$refs.forgetForm.resetFields();
          this.forgetTip = "";
        } else {
          if (this.optActive === "login") {
            this.$refs.loginForm.resetFields();
          } else {
            this.$refs.registerOneForm.resetFields();
          }
        }
      });
    }
  },
  methods: {
    encryptData,
    registerEncrypt,
    changeOptActive(val) {
      if (this.optActive === val) {
        return false;
      } else {
        this.loginMsgTip = "";
        this.registerMsgTip = "";
        this.optActive = val;
        if (val === "register") {
          this.$nextTick(() => {
            this.$refs.registerOneForm.resetFields();
            this.$refs.registerTwoForm.resetFields();
          });
        } else {
          this.$nextTick(() => {
            this.$refs.loginForm.resetFields();
          });
        }
      }
    },
    optReUser(val) {
      // 记住账号
      if (val) {
        window.localStorage.setItem("loginUserName", this.loginForm.username);
      }
    },
    readChange(val) {
      // 阅读协议勾选
      if (val) {
        this.showReadTip = false;
      }
    },
    /**
     * 验证验证码
     */
    async codeValidate() {
      const data = {
        token: this.registerTwoForm.code,
        phone: this.registerTwoForm.phone,
        name: "user-register"
      };
      const result = await checkSmsCaptha(data)
        .then(res => {
          this.registerMsgTip = "";
          return true;
        })
        .catch(() => {
          this.registerMsgTip = "验证码错误";
          return false;
        });
      return result;
    },
    // 显示登录的图片验证码
    loginBefore() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loginMsgTip = "";
          const captcha1 = new TencentCaptcha(
            this.$constants.APP_ID_MAP.LOGIN,
            res => this.captchaCallback(res)
          );
          captcha1.show(); // 显示验证码
        } else {
          return false;
        }
      });
    },
    // 验证登录的图片验证码
    async captchaCallback(res) {
      if (res.ticket) {
        this.loginBtnLoading = true;
        const param = {
          name: this.$constants.CAPTCHA_API_NAMES.LOGIN,
          ticket: res.ticket,
          nonce: res.randstr
        };
        const response = await tencentCaptcha(param);
        if (response.status === 200) {
          this.login();
        }
      }
    },
    // 发送登录请求
    async login() {
      var that = this;
      var username = this.$xss(this.loginForm.username);
      var password = this.$xss(this.loginForm.password);
      const params = {
        label: username,
        password: encryptData(password)
      };
      const res = await http.post(api.user.LOGIN(), params);

      var code = res || "";
      switch (code) {
        case 200:
          if (this.$route.query.ref) {
            localStorage.setItem("download_now", 1);
            location.href = this.$route.query.ref;
            return;
          }
          await this.$store.dispatch("init");
          that.$router.push({ path: "/" });
          break;
        default:
          this.loginBtnLoading = false;
          this.loginMsgTip = res;
        // this.captchaValid = false;
      }
    },
    // 注册点下一步
    registerNext() {
      this.$refs.registerOneForm.validate(valid => {
        if (valid) {
          this.registerStep = 2;
        }
      });
    },
    // 显示发送验证码的图片验证码
    sendCodeBefore() {
      const captcha1 = new TencentCaptcha(
        this.$constants.APP_ID_MAP.PHONE,
        res => this.sucessTencentCatpcha(res)
      );
      captcha1.show(); // 显示验证码
    },
    // 验证发送验证码的图片验证码
    async sucessTencentCatpcha(res) {
      if (res.ticket) {
        const param = {
          name: "phone-captcha",
          ticket: res.ticket,
          nonce: res.randstr
        };
        const response = await tencentCaptcha(param);
        if (response.status === 200) {
          this.getCode();
        }
      }
    },
    // 发送验证码
    async getCode() {
      let time = 60;
      const data = { phone: this.registerTwoForm.phone, name: "user-register" };
      this.sendCodeStatus = true;
      getSmsCaptha(data)
        .then(res => {
          if (res.status === 200) {
            this.timer = setInterval(() => {
              this.sendCodeText = `(${time}s)重新获取`;
              time--;
              if (time <= 0) {
                clearInterval(this.timer);
                this.sendCodeText = "重新获取";
                this.sendCodeStatus = false;
              }
            }, 1000);
          } else {
            this.$message.error("系统繁忙，请稍后重试");
            this.sendCodeStatus = false;
          }
        })
        .catch(e => {
          this.$message.error("系统繁忙，请稍后重试");
          this.sendCodeStatus = false;
        });
    },
    // 注册
    async register() {
      const temOneStr = JSON.stringify(this.registerOneForm);
      const temTwoStr = JSON.stringify(this.registerTwoForm);
      if (
        this.registerOneFormStr === temOneStr &&
        this.registerTwoFormStr === temTwoStr
      ) {
      } else {
        this.registerOneFormStr = temOneStr;
        this.registerTwoFormStr = temTwoStr;
        this.$refs.registerTwoForm.validate(async valid => {
          if (valid) {
            if (!this.registerTwoForm.readCheck) {
              this.showReadTip = true;
              return;
            }
            const codeValidateResult = await this.codeValidate();
            if (!codeValidateResult) {
              return;
            }
            this.registerBtnLoading = true;
            const params = {
              email: encodeURI(this.$xss(this.registerOneForm.email)),
              username: encodeURI(this.$xss(this.registerTwoForm.name)),
              phone: encodeURI(this.$xss(this.registerTwoForm.phone)),
              company: encodeURI(this.$xss(this.registerTwoForm.company)),
              password: encodeURI(this.$xss(this.registerOneForm.password)),
              position: encodeURI(this.$xss(this.registerTwoForm.position)),
              focus_area: encodeURI(
                this.$xss(this.registerTwoForm.focus_area.join(","))
              )
            };
            if (this.$route.query.id) {
              params.source = this.$route.query.id;
            }
            const token = getLocalStorage("thfp") || getCookie("thfp");
            if (token) {
              params.token = token;
            }
            const paramsEncrypt = this.registerEncrypt(JSON.stringify(params));
            console.log(paramsEncrypt);
            const data = {
              data: paramsEncrypt
            };
            const res = await http.post(api.user.REGISTER(), data);
            this.registerBtnLoading = false;
            if (res === 200) {
              this.registerMsgTip = "";
              this.registerSuccess = true;
            } else {
              if (res === "非法请求") {
                this.$message({
                  showClose: true,
                  dangerouslyUseHTMLString: true,
                  message:
                    '<div><p style="text-align:left;line-height:18px;font-size:12px;margin-right:15px;">请不要重复注册账号,如有疑问，请联系我司商务或致电400-809-3699</p></div>',
                  type: "error",
                  duration: 0
                });
              } else {
                this.registerMsgTip = res;
              }
            }
          } else {
            return false;
          }
        });
      }
    },
    // 找回密码前图片验证
    async findBefore() {
      const captcha1 = new TencentCaptcha(
        this.$constants.APP_ID_MAP.PASSWORD_FORGET,
        res => this.forgetTencentCatpcha(res)
      );
      captcha1.show(); // 显示验证码
    },
    // 验证找回密码的图片验证码
    async forgetTencentCatpcha(res) {
      if (res.ticket) {
        const param = {
          name: this.$constants.CAPTCHA_API_NAMES.PASSWORD_FORGET,
          ticket: res.ticket,
          nonce: res.randstr
        };
        const response = await tencentCaptcha(param);
        if (response.status === 200) {
          this.findPwd();
        }
      }
    },
    // 发送找回密码请求
    async findPwd() {
      var params = {
        email: this.$xss(this.forgetForm.email)
      };
      this.forgetBtnLoading = true;
      const res = await http.post(api.user.PASSWORD_FORGET(), params);
      this.forgetBtnLoading = false;
      if (res === 200) {
        this.forgetTip = "";
        this.dialogVisible = true;
      } else {
        this.forgetTip = res.slice(0, 12);
      }
    },
    // 打开反馈弹窗
    openFeedback() {
      this.feedbackForm.email = this.registerOneForm.email;
      this.feedBackVisible = true;
    },
    closeFeedback() {
      if (this.$refs.feedbackFormCom) {
        this.$refs.feedbackFormCom.clearValidate();
      }
      this.feedBackVisible = false;
    },
    submitFeedback() {
      this.$refs.feedbackFormCom.validate(async valid => {
        if (valid) {
          await postFeedBack(this.feedbackForm)
            .then(() => {
              this.feedbackSuccess = true;
            })
            .catch(() => {
              this.$message.error("发送反馈失败，请稍后重试");
            });
        }
      });
    }
  },
  mounted() {
    const user = window.localStorage.getItem("loginUserName");
    const tag = this.$route.query.tag;
    if (tag === "register") {
      this.optActive = "register";
    }
    if (user) {
      this.loginForm.username = user;
    }
  }
};
</script>
<style scoped lang="scss">
.login-index {
  min-height: 100%;
  background: url(../../assets/img/login/login-bg.png) no-repeat;
  background-size: 100% 100%;
}

.login-header {
  max-width: 1200px;
  padding: 0 20px;
  margin: 0 auto;
  height: 58px;
}

.login-header img {
  width: 138px;
  height: 42px;
  margin-top: 16px;
  cursor: pointer;
}

.content-box {
  width: 400px;
  box-sizing: border-box;
  margin: 10vh auto 0;
}

.content-box .wel-text {
  display: block;
  font-size: 36px;
  font-family: Helvetica;
  color: rgba(255, 255, 255, 1);
  line-height: 42px;
  margin-bottom: 20px;
}

.form-box {
  width: 100%;
  /* height: 100%; */
  background: rgba(255, 255, 255, 1);
  border-radius: 14px;
  padding: 76px 48px 106px;
  box-sizing: border-box;
}

.form-box.register-one-box {
  padding: 79px 48px 98px;
}

.form-box.register-two-box {
  padding: 38px 48px;
}

.form-box.forget-box {
  padding: 85px 48px;
}

.form-box .form-header {
  height: 38px;
  border-bottom: 1px solid rgba(222, 223, 228, 1);
  display: flex;
  margin-bottom: 40px;
}

.form-box .form-header.register-header {
  margin-bottom: 20px;
}

.form-box .form-header.forget-header {
  margin-bottom: 40px;
}

.form-box .form-header .header-item {
  height: 100%;
  padding: 6px 0 12px;
  box-sizing: border-box;
  margin-right: 30px;
  font-weight: 400;
  color: rgba(184, 187, 200, 1);
  line-height: 22px;
  letter-spacing: 1px;
  font-size: 16px;
  position: relative;
  cursor: pointer;
}

.form-box .form-header .header-item.active {
  padding: 0;
  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(64, 73, 100, 1);
  line-height: 25px;
  letter-spacing: 2px;
  border-bottom: 3px solid rgba(24, 174, 255, 1);
  top: 1px;
}

.form-box .form-header .header-item:last-of-type {
  margin-right: 0;
}

.other-opt-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 17px;
  margin-top: 20px;
  margin-bottom: 65px;
}

.other-opt-box .forget-text {
  color: rgba(24, 174, 255, 1);
  cursor: pointer;
}

.btn-msg-tip {
  position: absolute;
  right: 0;
  top: -24px;
  line-height: 18px;
  font-size: 12px;
  color: #f56c6c;
  white-space: nowrap;
  letter-spacing: 0;
}

.login-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 42px;
  text-align: center;
  background: rgba(24, 174, 255, 1);
  border-radius: 4px;
  cursor: pointer;
  position: relative;
}

.login-btn span {
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 1px;
  line-height: 22px;
}

.round-group {
  height: 36px;
  width: 36px;
  position: relative;
  margin-right: 10px;
  .round {
    height: 36px;
    width: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    opacity: 0;
  }

  .round.one {
    animation: roundAnimation 8s 6s ease-out infinite;
  }

  .round.two {
    animation: roundAnimation 8s 4s ease-out infinite;
  }

  .round.three {
    animation: roundAnimation 8s 2s ease-out infinite;
  }

  .round.four {
    animation: roundAnimation 8s 0s ease-out infinite;
  }

  .round.icon-wrapper {
    width: 18px;
    height: 18px;
    opacity: 1;
  }

  .round.icon-wrapper .iconfont {
    font-size: 10px;
    color: rgba(24, 174, 255, 1);
  }
}

.send-code-btn {
  width: 77px;
  height: 22px;
  line-height: 22px;
  text-align: center;
  background: rgba(24, 174, 255, 1);
  border-radius: 2px;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
}

.send-code-btn.disabled-btn {
  background-color: #9bb9fb;
  pointer-events: none;
}

.read-box {
  margin-bottom: 34px;
  position: relative;
}

.read-box .read-tip {
  position: absolute;
  bottom: -14px;
  line-height: 14px;
  font-size: 12px;
  color: #f56c6c;
}

.read-box a {
  font-size: 12px;
  color: rgba(24, 174, 255, 1);
}

.next-btn,
.send-set-btn {
  height: 42px;
  line-height: 42px;
  text-align: center;
  background: rgba(24, 174, 255, 1);
  border-radius: 4px;
  color: #fff;
  letter-spacing: 1px;
  font-size: 16px;
  cursor: pointer;
  position: relative;
}

.register-btn-group {
  display: flex;
  justify-content: space-between;
}

.register-btn-group .prev-btn {
  height: 42px;
  line-height: 42px;
  width: 142px;
  text-align: center;
  background: rgba(24, 174, 255, 0.16);
  border: 1px solid rgba(24, 174, 255, 1);
  box-sizing: border-box;
  border-radius: 4px;
  color: rgba(24, 174, 255, 1);
  letter-spacing: 1px;
  font-size: 16px;
  cursor: pointer;
  position: relative;
}

.register-btn-group .register-btn {
  height: 42px;
  line-height: 42px;
  width: 142px;
  text-align: center;
  background: rgba(24, 174, 255, 1);
  border-radius: 4px;
  color: #fff;
  letter-spacing: 1px;
  font-size: 16px;
  cursor: pointer;
  position: relative;
}

.more-power-tip {
  margin: 14px -8px 0;
  height: 17px;
  line-height: 17px;
  font-weight: 400;
  color: rgba(184, 187, 200, 1);
  font-size: 12px;
}

.more-power-tip i {
  color: rgba(24, 174, 255, 1);
  font-size: 12px;
}

.more-power-tip span {
  color: rgba(24, 174, 255, 1);
  cursor: pointer;
}

.return-login-btn {
  height: 42px;
  line-height: 42px;
  text-align: center;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  border: 1px solid rgba(24, 174, 255, 1);
  color: rgba(24, 174, 255, 1);
  font-size: 14px;
  cursor: pointer;
  margin-top: 15px;
}

.dialog-content {
  padding: 61px 0 37px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.dialog-content img {
  width: 50px;
  height: 37px;
  margin-bottom: 26px;
}

.dialog-content p {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(64, 73, 100, 1);
  line-height: 20px;
  margin-bottom: 28px;
}

.dialog-content .sure-btn {
  width: 178px;
  height: 39px;
  line-height: 39px;
  text-align: center;
  background: rgba(24, 174, 255, 1);
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  border-radius: 3px;
}

.register-success-box {
  background: rgba(255, 255, 255, 1);
  border-radius: 14px;
  width: 100%;
  box-sizing: border-box;
  padding: 130px 42px 137px 52px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.register-success-box img {
  width: 201px;
  height: 133px;
}

.register-success-box p {
  font-size: 16px;
  font-weight: 500;
  color: rgba(64, 73, 100, 1);
  line-height: 28px;
  margin-top: 20px;
}

.register-success-box p span {
  color: #4483fe;
}

@keyframes roundAnimation {
  0% {
    transform: translate(-50%, -50%) scale(0);
    opacity: 0.8;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.5);
    opacity: 0;
  }
}

@media only screen and (max-width: 768px) {
  .login-index {
    min-height: 100%;
    height: auto;
  }

  .content-box {
    width: 95%;
    padding: 10px;
    position: unset;
    transform: unset;
    margin: 0 auto;
    height: auto;
  }

  .content-box .wel-text {
    display: none;
  }

  .login-index .content-box .dot {
    display: none;
  }

  .form-box,
  .form-box.register-one-box {
    padding: 50px 28px;
    margin-top: 10px;
  }

  .form-box.register-two-box {
    padding: 30px 28px;
  }

  .form-box .form-header .header-item {
    font-size: 16px;
  }

  .form-box .form-header .header-item.active {
    font-size: 18px;
  }

  .read-box {
    margin-bottom: 20px;
  }

  .register-btn-group .prev-btn,
  .register-btn-group .register-btn {
    width: 120px;
    font-size: 15px;
  }

  .more-power-tip {
    margin: 14px -20px 0;
  }

  .register-success-box {
    padding: 120px 30px 120px 35px;
    margin-top: 50px;
  }

  .register-success-box img {
    width: 201px;
    height: 133px;
  }

  .register-success-box p {
    font-size: 14px;
    font-weight: 500;
    color: rgba(64, 73, 100, 1);
    line-height: 26px;
    margin-top: 20px;
  }
}
</style>

<style>
.login-index .ruleForm .el-select {
  width: 100%;
}

.login-index .ruleForm .el-input__inner {
  height: 42px;
  line-height: 42px;
}

.login-index .ruleForm .el-input__prefix {
  left: 10px;
}

.login-index .ruleForm .el-input--prefix .el-input__inner {
  padding-left: 37px;
}

.login-index .el-form-item {
  margin-bottom: 20px;
}

.login-index .el-form-item .error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
  position: absolute;
  top: 100%;
}

.login-index .el-form-item .error .feedback-btn {
  color: #077fef;
  text-decoration: underline;
  cursor: pointer;
}

.login-index .ruleForm .el-form-item__error {
  left: unset;
  right: 0;
}

.login-index .el-checkbox__label {
  line-height: 17px;
}

.login-index .el-checkbox__input.is-checked .el-checkbox__inner,
.login-index .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background: rgba(24, 174, 255, 1);
  border-color: rgba(24, 174, 255, 1);
}

.login-index .el-checkbox__inner:focus {
  border-color: rgba(24, 174, 255, 1);
}

.login-index .el-checkbox__input.is-checked + .el-checkbox__label {
  color: rgba(184, 187, 200, 1);
  font-size: 12px;
}

.login-index .el-checkbox {
  color: rgba(184, 187, 200, 1);
  font-size: 12px;
}

.login-index .el-checkbox__label {
  font-size: 12px;
}

.login-index .el-checkbox {
  height: 17px;
}

.login-index .el-input__suffix {
  display: flex;
  align-items: center;
  right: 8px;
}

.login-index .success-tip-dialog .el-dialog__header {
  padding: 0;
}

.login-index .success-tip-dialog .el-dialog__body {
  padding: 0;
}

.feedbackDialog .feedback-success {
  font-size: 16px;
  line-height: 24px;
}
</style>
